import React from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button } from "reactstrap";
import { unstrictWorkstations } from "../../store/actions";

const UnstrictWorkstation = function (props) {
  let ws = props.ws;

  let user = JSON.parse(localStorage.getItem("authUser"));

  const unstrictWorkstations = (event) => {
    event.preventDefault();
    props.unstrictWorkstations(ws, user.token, props.history);
  };

  return (
    <React.Fragment>
      <Button
        className="btn btn-success waves-effect waves-light buttonStatus wsButton"
        onClick={(event) => unstrictWorkstations(event)}
      >
        {" "}
        <i className="far fa-hand-paper font-size-16 align-middle mr-2"></i>{" "}
        {props.t("Strict")}
      </Button>
    </React.Fragment>
  );
};

const mapStateProps = (state) => {
  const { loadingUnstrictWs } = state.unstrictWorkstations;
  return { loadingUnstrictWs };
};

export default withRouter(
  connect(mapStateProps, {
    unstrictWorkstations,
  })(withNamespaces()(UnstrictWorkstation))
);
